<template>
  <div class="singleRegister">
    <div class="main">
      <van-form @submit="onSubmit" input-align="left">
        <div class="card">
          <div class="card_item">
            <van-field
              :value="competitionIds | competitionIdsStr"
              name="competition"
              label="赛事"
              required
              clickable
              readonly
              placeholder="请选择"
              right-icon="arrow"
              :rules="contestantRules.competitionIds"
              @click="showConpetitionPickerHandle"
            >
            </van-field>
          </div>
          <div class="card_item">
            <van-field
              v-model="contestant.realName"
              name="realName"
              label="参赛人姓名"
              required
              :rules="contestantRules.realName"
            />
          </div>
          <div class="card_item">
            <van-field
              name="picUrl"
              label="报名照"
              required
              :rules="contestantRules.picUrl"
            >
              <template #input>
                <div>
                  <van-uploader
                    v-model="fileList"
                    :max-count="1"
                    :after-read="afterRead"
                    @delete="deleteImage"
                  >
                  </van-uploader>
                  <p class="tip" style="text-align: left;">使用电子证件照</p>
                </div>
              </template>
            </van-field>
          </div>
          <div class="card_item">
            <van-field
              name="competitionMode"
              label="参赛方式"
              required
              :rules="rules.competitionMode"
            >
              <template #input>
                <van-radio-group v-model="form.competitionMode" direction="horizontal">
                  <van-radio name="1" checked-color="#00CBCC">线上</van-radio>
                  <van-radio name="2" checked-color="#00CBCC">线下</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="card_item" v-if="form.competitionMode == '1'">
            <van-field
              name="videoUrl"
              label="视频"
            >
              <template #input>
                <van-uploader
                  v-model="videoFileList"
                  accept="video/*"
                  :max-count="1"
                  :after-read="afterVideoRead"
                  @delete="deleteVideo"
                >
                  <template #preview-cover="{ file }">
                    <div class="preview-cover van-ellipsis" v-if="form.videoUrl">
                      <video style="width: 100%;height: 100%;" controls :src="form.videoUrl"></video>  
                    </div>
                  </template>
                </van-uploader>
              </template>
            </van-field>
          </div>
          <div class="card_item">
            <van-field
              name="gender"
              label="性别"
              required
              :rules="contestantRules.gender"
            >
              <template #input>
                <van-radio-group v-model="contestant.gender" direction="horizontal">
                  <van-radio name="1" checked-color="#00CBCC">男</van-radio>
                  <van-radio name="2" checked-color="#00CBCC">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>
          </div>
          <div class="card_item">
            <van-field
              v-model="contestant.nation"
              name="nation"
              label="民族"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="contestant.birthForYear"
              name="birthForYear"
              label="出生年份"
              required
              clickable
              readonly
              placeholder="请选择"
              :rules="contestantRules.birthForYear"
              @click="showBirthForYearPicker = true"
            >
            </van-field>
          </div>
          <div class="card_item">
            <van-field
              v-model="contestant.certificateType"
              name="certificateType"
              label="证件类型"
              required
              clickable
              readonly
              placeholder="请选择"
              right-icon="arrow"
              @click="showCertificateTypePicker = true"
            >
            </van-field>
          </div>
          <div class="card_item" v-if="contestant.certificateType == '身份证'">
            <van-field
              v-model="contestant.certificateCode"
              name="certificateCode"
              label="证件号码"
              required
              maxlength="18"
              :rules="contestantRules.certificateCode"
            />
          </div>
          <div class="card_item" v-else>
            <van-field
              v-model="contestant.certificateCode"
              name="certificateCode"
              label="证件号码"
              required
              :rules="contestantRules.certificateCode2"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="form.repertoire"
              name="repertoire"
              label="参赛曲目"
              required
              :rules="rules.repertoire"
            />
          </div>
          <div class="card_item" v-if="selectCompetitiontype && selectCompetitiontype.professionals.length > 1">
            <van-field
              v-model="selectProfessional.name"
              label="使用乐器"
              readonly
            />
          </div>
        </div>

        <div class="card">
          <div class="card_item">
            <van-field
              v-model="form.regionId"
              name="regionId"
              label="所在学校地区"
              placeholder="请选择"
              required
              clickable
              readonly
              right-icon="arrow"
              :rules="rules.regionId"
              @click="showRegionIdPicker = true"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="contestant.currentSchool"
              name="currentSchool"
              label="就读学校名称"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="contestant.schoolAddress"
              name="schoolAddress"
              label="就读学校地址"
            />
          </div>
          <div class="card_item" v-if="channel">
            <van-field
              v-model="channel.name"
              label="报名渠道"
              readonly
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="form.agency"
              name="agency"
              label="报名机构名称"
              required
              :rules="rules.agency"
              placeholder="xxx 机构徐汇校区"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="form.teacherName"
              name="teacherName"
              label="指导老师"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="contestant.postAddress"
              name="postAddress"
              label="证书邮寄地址"
              required
              :rules="contestantRules.postAddress"
            />
          </div>
        </div>

        <div class="tip">
          按照x省x市x县x街道(精确到门牌号)
        </div>

        <div class="card">
        </div>

        <div class="card">
          <div class="card_item">
            <van-field
              v-model="contestant.parentName"
              name="parentName"
              label="家长姓名"
              required
              :rules="contestantRules.parentName"
            />
          </div>
          <div class="card_item">
            <van-field
              v-model="contestant.mobile"
              type="tel"
              name="mobile"
              label="联系电话"
              required
              maxlength="11"
              :rules="contestantRules.mobile"
            />
          </div>
        </div>

        <!-- <div class="rule_box">
          <van-radio-group v-model="ruleChecked">
            <van-radio class="rule_box_radio" :name="true">
              <div class="rule_box_content">
                我已阅读并同意
                <span>《{{tongyishuText}}同意书》</span>
                ，愿意承担相关风险
              </div>
            </van-radio>
          </van-radio-group>
        </div> -->

        <div class="submit">
          <van-button block color="#00CBCC" type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>

    <!-- 出生年份 -->
    <van-popup v-model="showBirthForYearPicker" position="bottom">
      <van-picker
        title="出生年份"
        show-toolbar
        :columns="birthNums"
        @confirm="birthForYearConfirm"
        @cancel="birthForYearCancel"
      />
    </van-popup>

    <!-- 证件类型 -->
    <van-popup v-model="showCertificateTypePicker" position="bottom">
      <van-picker
        title="证件类型"
        show-toolbar
        :columns="certificateTypeList"
        @confirm="certificateTypeConfirm"
        @cancel="showCertificateTypePicker = false"
      />
    </van-popup>

    <!-- 赛事 -->
    <van-popup class="showConpetitionPicker" v-model="showConpetitionPicker" position="bottom" round>
      <div class="header_box">
        <span @click="closeConpetitionPickerHandle">取消</span>
        <span @click="competitionsConfirm">确认</span>
      </div>
      <van-checkbox-group v-model="showConpetitionPickerList">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in competitionList"
            clickable
            :key="index"
            :title="`${item.name}`"
            @click="selectCompetition(item)"
          >
            <template #right-icon>
              <van-checkbox :name="item.id" ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>

    <!-- 所在学校地区 -->
    <van-popup v-model="showRegionIdPicker" position="bottom">
      <van-picker
        title="所在学校地区"
        show-toolbar
        value-key="name"
        :columns="regionList"
        @confirm="regionIdConfirm"
        @cancel="showRegionIdPicker = false"
      />
    </van-popup>

    <!-- 报名成功 -->
    <van-popup v-model="popupShow" round>
      <div class="popup_main">
        <img class="close_icon" src="@/assets/olympicMusicShow/delete.png" @click="popupShow = false">
        <div class="success_icon_box">
          <img class="success_icon" src="@/assets/olympicMusicShow/success.png">
        </div>

        <div class="title">报名成功</div>
        <div class="text">请关注后续手机短信通知</div>

        <div class="btn" @click="navToRecord">查看报名详情</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Form, Field, Uploader, Button, RadioGroup, Radio, Popup, Cell, CellGroup, Icon, Picker, Toast, Checkbox, CheckboxGroup } from 'vant'

import { ApiQueryregions, ApiSignupCompetition, uploadFile, ApiGetcompetitionlist } from '@/api/olympicMusicShow.js'
import { ossStsToken } from '@/api/multipartUpload'
const OSS = require('ali-oss')

import { deepClone } from '@/utils/index'
import { validMobile, validIDCard, validIDCardByBirth, validPassport } from '@/utils/validate.js'

let that

export default {
  name: 'singleRegister',
  components: {
    vanForm: Form,
    vanField: Field,
    vanUploader: Uploader,
    vanButton: Button,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    vanPopup: Popup,
    vanCell: Cell,
    vanCellGroup: CellGroup,
    vanIcon: Icon,
    vanPicker: Picker,
    vanCheckbox: Checkbox,
    vanCheckboxGroup: CheckboxGroup,
  },
  filters: {
    competitionIdsStr(list) {
      let str = []
      list.forEach(ele => {
        let find = that.competitionList.find(ele2 => ele2.id === ele)
        if (find) {
          str.push(find.name)
        }
      })
      return str.join(',')
    }
  },
  data() {
    return {
      competitionIds: [],
      form: {
        regionId: null,
        agency: null,
        teacherName: null,
        repertoire: null,
        competitionMode: null,
        videoUrl: null,
      },
      contestant: {
        realName: null,
        gender: null,
        nation: null,
        birthForYear: null,
        certificateType: '身份证',
        certificateCode: null,
        postAddress: null,
        parentName: null,
        mobile: null,
        picUrl: null,
        currentSchool: null,
        schoolAddress: null,
      },
      fileList: [],
      videoFileList: [],
      rules: {
        regionId: [{ required: true, message: '请选择所在学校地区' }],
        agency: [{ required: true, message: '请填写指导机构名称' }],
        competitionMode: [{ required: true, message: '请选择参赛方式' }],
        repertoire: [{ required: true, message: '请填写参赛名称' }],
        // agencyPhone: [
        //   { required: true, message: '请填写推荐机构电话' },
        //   { validator: validMobile,  message: '手机号格式不正确'}
        // ],
      },
      contestantRules: {
        competitionIds: [{ required: true, message: '请选择赛事' }],
        realName: [{ required: true, message: '请填写参赛人姓名' }],
        gender: [{ required: true, message: '请选择性别' }],
        birthForYear: [{ required: true, message: '请选择出生年份' }],
        certificateType: [{ required: true, message: '请选择证件类型' }],
        certificateCode: [
          { required: true, message: '请填写证件号码' },
          { validator: validIDCard,  message: '身份证号码格式不正确'},
          { validator: (value) => {
            return validIDCardByBirth(value, this.contestant.birthForYear)
          },  message: '身份证号码与出生年份不匹配'},
        ],
        certificateCode2: [
          { required: true, message: '请填写证件号码' },
          { validator: validPassport,  message: '证件号码格式不正确'},
        ],
        postAddress: [{ required: true, message: '请填写证书邮寄地址' }],
        parentName: [{ required: true, message: '请填写家长姓名' }],
        picUrl: [{ required: true, message: '请上传报名照' }],
        // videoUrl: [{ required: true, message: '请上传视频' }],
        mobile: [
          { required: true, message: '请填写联系电话' },
          { validator: validMobile,  message: '手机号格式不正确'}
        ],
      },
      // 赛事
      showConpetitionPicker: false,
      competitionList: [],
      showConpetitionPickerList: [],
      // 出生年份
      showBirthForYearPicker: false,
      showProfessionalPicker: false,
      // 证件类型
      showCertificateTypePicker: false,
      certificateTypeList: [
        { text: '身份证', value: 1 },
        { text: '护照及港澳通行证', value: 2 },
      ],
      // 所在学校地区
      showRegionIdPicker: false,
      regionList: [],
      regionIdIndex: [],
      // 同意规则
      ruleChecked: false,
      popupShow: false,
      recordId: null
    }
  },
  computed: {
    tongyishuText() {
      if (this.competitionIds.length > 0) {
        let id = this.competitionIds[0]
        let find = this.competitionList.find(ele => ele.id === id)
        if (find) {
          return find.name
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    selectCompetitiontype: {
      get() {
        return this.$store.state.olympicMusicShow.selectCompetitiontype
      }
    },
    selectProfessional: {
      get() {
        return this.$store.state.olympicMusicShow.selectProfessional
      }
    },
    channels: {
      get() {
        return this.$store.state.olympicMusicShow.channels
      }
    },
    channelId: {
      get() {
        return this.$store.state.olympicMusicShow.channelId
      }
    },
    competitionId: {
      get() {
        return this.$store.state.olympicMusicShow.competitionId
      }
    },
    channel() {
      let channels = this.channels
      let channelId = this.channelId
      if ((channelId && channelId != 0) && (channels && channels.length > 0)) {
        let find = channels.find(ele => ele.id == channelId)
        if (find) {
          return find
        } else {
          return null
        }
      } else {
        return null
      }
    },
    group: {
      get() {
        return this.$store.state.olympicMusicShow.group
      }
    },
    birthNums() {
      if (this.group) {
        return this.group.birthNums
      } else {
        let birthNums = []
        let i = 1980
        
        do {
          birthNums.push(i)
          i++
        } while (i <= 2022)

        return birthNums
      }
    },
    competitiontypesName() {
      if (this.selectCompetitiontype) {
        return this.selectCompetitiontype.name
      } else {
        return ''
      }
    }
  },
  mounted() {
    that = this

    document.title = this.competitiontypesName + '填写报名信息'

    this.form.entryTypeId = this.$route.query.typeId
    this.form.professionalId = this.$route.query.professionalId || 0
    this.form.entryGroupId = this.$route.query.groupId || 0

    // 数据回显
    this.regionIdIndex = this.$store.state.olympicMusicShow.regionIdIndex

    this.getQueryregions()
    this.getApiGetcompetitionlist()
  },
  methods: {
    async client() {
      const info = await ossStsToken();
      return new OSS({
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: 'oss-cn-shanghai',
        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
        accessKeyId: info.data.accessKeyId,
        accessKeySecret: info.data.accessKeySecret,
        // 从STS服务获取的安全令牌（SecurityToken）。
        stsToken: info.data.stsToken,
        refreshSTSToken: async () => {
          // 向您搭建的STS服务获取临时访问凭证。
          const info = await ossStsToken();
          return {
            accessKeyId: info.data.accessKeyId,
            accessKeySecret: info.data.accessKeySecret,
            stsToken: info.data.stsToken
          }
        },
        // 刷新临时访问凭证的时间间隔，单位为毫秒。
        refreshSTSTokenInterval: 300000,
        // 填写Bucket名称。
        bucket: 'dayulong'
      })
    },
    async afterVideoRead(file) {
      const that = this
      let checkpoint //断点续传的关键变量
      this.videoFileList[0].status = 'uploading'
      this.videoFileList[0].message = '上传中...'
      async function multipartUpload () {
        let fileName = file.file.name
        // 支持断点续传，只尝试6次，
        for (let i = 0; i < 6; i++) {
          try {
            let client = await that.client()
            
            let filePath = ''
            if (location.host === 'www.dayulong.cn') {
              filePath = `production/web/${fileName}`
            } else {
              filePath = `development/web/${fileName}`
            }
            const result = await client.multipartUpload(filePath, file.file, {
              checkpoint,
              async progress (p, cpt) {
                // p进度条的值
                checkpoint = cpt
                that.showProgress = true
                that.progress = Math.floor(p * 100)
              }
            })
            that.showProgress = false
            that.videoFileList[0].status = 'done'
            that.videoFileList[0].message = '上传成功'
            let videoUrl = 'https://oss.dayulong.cn/' + result.name
            that.form.videoUrl = videoUrl
            break
          } catch (e) {
            that.videoFileList[0].status = 'failed'
            that.videoFileList[0].message = '上传失败'
            setTimeout(function () { }, 1000)
          }
        }
      }
      multipartUpload()
    },
    getQueryregions() {
      let params = {
        parentId: 0
      }

      ApiQueryregions(params).then(res => {
        if (res.code === 200) {
          this.regionList = res.data.map(ele1 => {
            ele1.children = ele1.childs
            delete ele1.childs

            ele1.children = ele1.children.map(ele2 => {
              ele2.children = ele2.childs
              delete ele2.childs

              ele2.children = ele2.children.map(ele3 => {
                delete ele3.childs

                return ele3
              })

              return ele2
            })

            return ele1
          })
        } else {
          this.regionList = []
        }
      })
    },
    getApiGetcompetitionlist() {
      ApiGetcompetitionlist().then(res => {
        if (res.code === 200) {
          this.competitionList = res.data
        } else {
          this.competitionList = []
        }

        this.competitionIds = this.competitionId ? [Number(this.competitionId)] : []
      })
    },
    birthForYearCancel() {
      this.showBirthForYearPicker = false
    },
    birthForYearConfirm(value, index) {
      this.contestant.birthForYear = value
      this.showBirthForYearPicker = false
    },
    certificateTypeConfirm(value, index) {
      this.contestant.certificateType = value.text
      this.contestant.certificateCode = ''
      this.showCertificateTypePicker = false
    },
    regionIdConfirm(value, index) {
      this.form.regionId = value.join('/')
      this.regionIdIndex = index
      this.showRegionIdPicker = false
    },
    showConpetitionPickerHandle() {
      this.showConpetitionPickerList = deepClone(this.competitionIds)
      this.showConpetitionPicker = true
    },
    closeConpetitionPickerHandle() {
      this.showConpetitionPickerList = []
      this.showConpetitionPicker = false
    },
    selectCompetition() {},
    competitionsConfirm() {
      this.competitionIds = deepClone(this.showConpetitionPickerList)
      this.closeConpetitionPickerHandle()
    },
    navToRecord() {
      this.$router.push({ path: 'record', query: { id: this.recordId } })
    },
    // 上传图片
    afterRead(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      this.fileList[0].status = 'uploading'
      this.fileList[0].message = '上传中...'
      uploadFile(formData).then((res) => {
        if (res.code === 200) {
          this.fileList[0].status = 'done'
          this.fileList[0].message = '上传成功'
          this.contestant.picUrl = res.data.filePath
        } else {
          this.fileList[0].status = 'failed'
          this.fileList[0].message = '上传失败'
          this.contestant.picUrl = null
          this.$toast(res.msg)
        }
      }).catch(() => {
        this.fileList[0].status = 'failed'
        this.fileList[0].message = '上传失败'
        this.contestant.picUrl = null
      })
    },
    deleteImage() {
      this.contestant.picUrl = ''
      this.fileList = []
    },
    deleteVideo() {
      this.form.videoUrl = ''
      this.videoFileList = []
    },
    onSubmit() {
      if (!this.contestant.picUrl) {
        this.$toast('请上传报名照')
        return false
      }
      
      let newContestant = deepClone(this.contestant)
      let newForm = deepClone(this.form)
      this.$store.commit('olympicMusicShow/setSingleContestant', newContestant)
      this.$store.commit('olympicMusicShow/setSingleForm', newForm)
      this.$store.commit('olympicMusicShow/setRegionIdIndex', this.regionIdIndex)

      // if (!this.ruleChecked) {
      //   Toast('请阅读并同意《奥林匹克青少年音乐展演同意书》')
      //   return false
      // }

      let params = deepClone(this.$store.state.olympicMusicShow.singleParams)
      if (this.contestant.certificateType === '身份证') {
        params.contestants[0].certificateType = 1
      } else {
        params.contestants[0].certificateType = 2
      }

      if (params.competitionMode != '1') {
        params.videoUrl = ''
      }

      params.regionId = this.regionList[this.regionIdIndex[0]].children[this.regionIdIndex[1]].children[this.regionIdIndex[2]].id
      params.userId = this.$store.state.index.userInfo.userId
      params.competitionIds = this.competitionIds

      ApiSignupCompetition({
        register: params
      }).then(res => {
        if (res.code === 200) {
          this.recordId = res.data
          this.popupShow = true
        } else {
          Toast(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/css/flexable.scss';

.singleRegister {
  .preview-cover {
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background: #FFF;
  }

  .van-cell {
    padding: 0;
    padding-left: 16px;
  }
  .van-cell__title {
    font-size: px2rem(32);
    font-weight: 500;
    color: #1F1F1F;
  }
  
  .card_item {
    &.category {
      .van-radio-group--horizontal {
        justify-content: flex-end;
      }
      .van-radio {
        margin-bottom: 17px;
      }
    }

    .van-uploader__upload {
      margin-right: 0;
      margin-bottom: 0;
    }
  }

  .showConpetitionPicker {
    .header_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 10px 10px 0 10px;
      box-sizing: border-box;
      span {
        &:first-child {
          color: #8997A0;
        }
        &:last-child {
          color: #3AC8CA;
        }
      }
    }
    .van-checkbox-group {
      width: 100%;
      max-height: 70vh;
      padding: 10px;
      box-sizing: border-box;
      overflow: auto;
      .van-cell {
        padding: 5px 0;
      }
    }
  }
}
</style>

<style lang="scss">
@import '../../assets/css/flexable.scss';

.singleRegister {
  width: 100%;
  min-height: 100vh;
  background-color: #F5F5F9;
  .main {
    padding-top: px2rem(30);
    .card {
      margin-bottom: 3.73vw;
      width: 100%;
      padding: 0 3.73vw 0 4.27vw;
      background-color: #fff;
      box-sizing: border-box;
      &:last-child {
        margin-bottom: 0;
      }
      .tip {
        text-align: center;
        font-size: px2rem(22);
        font-weight: 500;
        color: #8997A0;
      }
      .card_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 4.27vw 0;
        border-bottom: 1px solid #F3F4F6;
        &:last-child {
          border-bottom: 0;
        }
      }
    }
    .rule_box {
      padding-top: px2rem(30);
    }
    .rule_box_radio {
      align-items: flex-start;
      padding-left: px2rem(40);
      padding-right: px2rem(60);
      box-sizing: border-box;
      .rule_box_content {
        text-align: left;
        font-size: px2rem(22);
        font-weight: 500;
        color: #8997A0;
        span {
          color: #1678DB;
        }
      }
    }
    .submit {
      width: 100%;
      padding: 40px 20px 44px 20px;
      box-sizing: border-box;
    }
  }

  .popup_main {
    position: relative;
    width: px2rem(608);
    height: px2rem(647);
    .close_icon {
      position: absolute;
      top: px2rem(26);
      right: px2rem(26);
      z-index: 1;
      width: px2rem(52);
      height: px2rem(52);
    }
    .success_icon_box {
      margin-bottom: px2rem(73);
      width: 100%;
      padding-top: px2rem(103);
      .success_icon {
        display: block;
        margin: 0 auto;
        width: px2rem(261);
        height: px2rem(157);
      }
    }
    .title {
      margin-bottom: px2rem(22);
      text-align: center;
      font-size: px2rem(36);
      font-weight: bold;
      color: #1F1F1F;
      line-height: 1;
    }
    .text {
      margin-bottom: px2rem(70);
      text-align: center;
      font-size: px2rem(32);
      font-weight: 500;
      color: #585858;
      line-height: 1;
    }
    .btn {
      margin: 0 auto;
      width: px2rem(490);
      height: px2rem(95);
      text-align: center;
      line-height: px2rem(95);
      font-size: px2rem(30);
      font-weight: 500;
      color: #fff;
      border-radius: px2rem(47);
      background-color: #3AC8CA;
    }
  }
}
</style>